import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Star, LayoutDashboard, LogOut, Crown, Wand2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import AuthModal from "@/components/AuthModal";

export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [showAuth, setShowAuth] = useState(false);

  return (
    <header className="sticky top-0 z-40 backdrop-blur-xl bg-white/40 border-b border-white/50">
      <div className="max-w-5xl mx-auto px-4 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2" data-testid="nav-logo">
          <Star className="w-5 h-5 fill-pink-400 text-pink-400" />
          <span className="font-playfair text-xl font-bold text-foreground">Nail Coach</span>
        </Link>

        <div className="flex items-center gap-2">
          <Button variant="ghost" onClick={() => navigate("/occasions")} className="rounded-full text-foreground hidden sm:inline-flex" data-testid="nav-inspire-btn">
            <Wand2 className="w-4 h-4 mr-1" /> Inspire
          </Button>
          {user ? (
            <>
              {user.is_subscribed && (
                <span className="hidden sm:inline-flex items-center gap-1 text-xs px-3 py-1 rounded-full bg-gradient-to-r from-pink-500 to-purple-500 text-white">
                  <Crown className="w-3 h-3" /> Premium
                </span>
              )}
              <Button variant="ghost" onClick={() => navigate("/dashboard")} className="rounded-full text-foreground" data-testid="nav-dashboard-btn">
                <LayoutDashboard className="w-4 h-4 mr-1" /> Dashboard
              </Button>
              <button onClick={() => navigate("/dashboard")} className="w-9 h-9 rounded-full overflow-hidden bg-secondary flex items-center justify-center text-primary font-semibold" data-testid="nav-avatar">
                {user.picture ? <img src={user.picture} alt="" className="w-full h-full object-cover" /> : (user.name || user.email || "U")[0].toUpperCase()}
              </button>
              <Button variant="ghost" size="icon" onClick={logout} className="rounded-full text-muted-foreground" data-testid="nav-logout-btn">
                <LogOut className="w-4 h-4" />
              </Button>
            </>
          ) : (
            <Button onClick={() => setShowAuth(true)} className="rounded-full bg-primary hover:bg-primary/90" data-testid="nav-login-btn">
              Log in
            </Button>
          )}
        </div>
      </div>
      <AuthModal isOpen={showAuth} mode="login" onClose={() => setShowAuth(false)} />
    </header>
  );
}
